import { Button } from '@monksflow/monks-ui';
import { PlusIcon, Trash2Icon } from 'lucide-react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import SentimentExcitedIcon from '@/shared/assets/images/sentiment_excited.svg';
import { OptimizedImage } from '@/shared/ui';

import { FieldLabel, FormSection, PersonaTextField } from '../../PersonaFormSections';
import { isNestedFieldRequired } from '../EditPersonaForm.schema';
import { useEditPersonaFormContext } from '../hooks/useEditPersonaFormContext';

export function GainsSection() {
  const { t } = useTranslation('audiences');

  const { control, gainsArray } = useEditPersonaFormContext();
  const { fields, append, remove } = gainsArray;
  const canDelete = fields.length > 1;

  return (
    <FormSection
      icon={<OptimizedImage src={SentimentExcitedIcon} alt="" className="size-6" />}
      title={t('audiences.gainsSection.gains')}
      badgeVariant="positive"
      headerAction={
        <Button
          size="sm"
          onClick={() =>
            append({
              description: '',
            })
          }
        >
          {t('audiences.gainsSection.addGain')}
          <PlusIcon />
        </Button>
      }
    >
      <div className="flex flex-col gap-4">
        <FieldLabel required={isNestedFieldRequired('gains', 'description')}>
          {t('audiences.gainsSection.description')}
        </FieldLabel>

        {fields.map((field, index) => (
          <div key={field.id} className="flex items-start gap-4">
            <Controller
              name={`gains.${index}.description`}
              control={control}
              render={({ field: descField, fieldState: { error } }) => (
                <PersonaTextField
                  {...descField}
                  className="flex-1"
                  aria-label={t('audiences.gainsSection.description')}
                  placeholder={t('audiences.gainsSection.description')}
                  error={error?.message}
                />
              )}
            />
            <Button
              variant="ghost"
              size="icon"
              // Tessra has no ghost-destructive variant; the red is the affordance.
              className="mt-0.5 text-destructive"
              aria-label={t('audiences.gainsSection.removeGain')}
              onClick={() => remove(index)}
              disabled={!canDelete}
            >
              <Trash2Icon />
            </Button>
          </div>
        ))}
      </div>
    </FormSection>
  );
}
